<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>定期挖矿详情</el-breadcrumb-item>
        </el-breadcrumb>

        <el-button type="danger" @click="addMiningRegularCoinDialog" style="margin: 20px 0">增 加</el-button>
        <el-button type="primary" style="margin: 20px 20px" @click="backPage">返 回</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="regularId" fixed="left" label="期数配置ID"></el-table-column>
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="totalAmount" label="募集总数"></el-table-column>
            <el-table-column prop="nowAmount" label="当前募集数"></el-table-column>
            <el-table-column prop="minAmount" label="最小募集数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userSingleLimit" label="单人最大募集数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userCount" label="用户参与数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="days" label="挖矿天数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="scale" label="小数位" show-overflow-tooltip></el-table-column>
            <el-table-column prop="incomeCoin" label="收益币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="yearRate" label="预期年化" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sort" label="优先级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.status | statusFormat}}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="500">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateMiningRegularCoinDialog(scope.row)">编辑</el-button>
                    <el-button type="primary" @click="calculateMiningRegularCoinIncomeDialog(scope.row.id)">收益计算
                    </el-button>
                    <el-button type="primary" @click="transferMiningRegularCoinIncomeDialog(scope.row.id)">收益发放
                    </el-button>
                    <el-button type="primary" @click="miningRegularCoinIncomeDetailDialog(scope.row.id)">订单明细
                    </el-button>
                    <el-button type="danger" @click="deleteRegularCoin(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--新增或修改弹框-->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="期数配置ID：" prop="regularId" style="padding-top: 20px">
                    <el-input v-model="addData.regularId" disabled style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="币种：" prop="coinType" style="padding-top: 20px">
                    <el-autocomplete class="inline-input" style="width: 500px"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="收益币种：" prop="incomeCoin" style="padding-top: 20px">
                    <el-input v-model="addData.incomeCoin" placeholder="收益币种" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="募集总数：" prop="totalAmount" style="padding-top: 20px">
                    <el-input v-model="addData.totalAmount" placeholder="募集总数(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="最小募集数：" prop="minAmount" style="padding-top: 20px">
                    <el-input v-model="addData.minAmount" placeholder="最小募集数(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="单人最大募集数：" prop="userSingleLimit" style="padding-top: 20px">
                    <el-input v-model="addData.userSingleLimit" placeholder="单人最大募集数(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="挖矿天数：" prop="days" style="padding-top: 20px">
                    <el-input v-model="addData.days" placeholder="挖矿天数(正整数：0＜X≤999)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="小数位数：" prop="scale" style="padding-top: 20px">
                    <el-input v-model="addData.scale" placeholder="小数位数(正整数：0＜X≤8)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="预期年化：" prop="yearRate" style="padding-top: 20px">
                    <el-input v-model="addData.yearRate" placeholder="预期年化(0＜X≤1)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="优先级：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.sort" placeholder="优先级(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addMiningRegularCoin">确 定</el-button>
            </span>
        </el-dialog>

        <!--收益计算和发放-->
        <el-dialog :title="regularTitle" :visible.sync="regularDialogVisible" width="1000px" @close="clearDataOne"
                   :close-on-click-modal="false">
            <el-form label-width="150px" inline>
                <el-form-item label="币种：" style="width: 300px">{{coinIncomeDetail.coinType}}</el-form-item>
                <el-form-item label="挖矿币种价格：" style="width: 300px">{{coinIncomeDetail.coinPrice}}</el-form-item>
                <el-form-item label="收益币种：" style="width: 300px">{{coinIncomeDetail.incomeCoin}}</el-form-item>
                <el-form-item label="收益币种价格：" style="width: 300px">{{coinIncomeDetail.incomeCoinPrice}}
                </el-form-item>
                <el-form-item label="总共募集：" style="width: 300px">{{coinIncomeDetail.totalAmount}}</el-form-item>
                <el-form-item label="实际募集：" style="width: 300px">{{coinIncomeDetail.nowAmount}}</el-form-item>
                <el-form-item label="预计年化：" style="width: 300px">{{coinIncomeDetail.yearRate}}</el-form-item>
                <el-form-item label="预估发放数量：" style="width: 300px">{{coinIncomeDetail.estimateIncomeAmount}}
                </el-form-item>
                <el-form-item label="实际发放数量：" style="width: 300px">{{coinIncomeDetail.incomeAmount}}</el-form-item>
                <el-form-item label="公告账户余额：" style="width: 300px">{{coinIncomeDetail.publicBalance}}
                </el-form-item>
            </el-form>

            <el-form label-width="150px" v-if="calculateMiningRegularCoinIncome">
                <el-form-item label="发放数量：" style="width: 300px">
                    <el-input v-model="coinIncomeOption.imcomeAmount" placeholder="请输入发放数量"
                              style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button v-if="calculateMiningRegularCoinIncome" type="danger" :loading="loading"
                           @click="calculateIncome">计 算</el-button>
                <el-button v-if="!calculateMiningRegularCoinIncome" type="danger" :loading="loading"
                           @click="transferIncome">发 放</el-button>
            </span>
        </el-dialog>

        <!--订单明细-->
        <el-dialog title="订单明细" :visible.sync="orderDialogVisible" fullscreen @close="clearDataTwo"
                   :close-on-click-modal="false">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="orderList" :row-key="() => Math.random()">
                <el-table-column prop="period" label="期数"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="amount" label="存入数量"></el-table-column>
                <el-table-column prop="yearRate" label="预期年化"></el-table-column>
                <el-table-column prop="days" label="挖矿天数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="miningTime" label="挖矿开始时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.miningTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="incomeAmount" label="收益数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="incomeCoin" label="收益币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.status | orderStatusFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="orderDialogVisible=false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'Regular',
        data() {
            return {
                dataList: [],
                coinTypes: [],
                orderList: [],
                total: 0,
                queryParams: {regularCoinId: "", page: 1, size: 10},
                currId: "",
                title: "新增",
                regularTitle: "",
                dialogVisible: false,
                regularDialogVisible: false,
                calculateMiningRegularCoinIncome: false,
                orderDialogVisible: false,
                addData: {
                    id: "",
                    regularId: "",
                    coinType: "",
                    incomeCoin: "",
                    totalAmount: "",
                    minAmount: "",
                    userSingleLimit: "",
                    days: "",
                    scale: "",
                    yearRate: "",
                    sort: "",
                },
                addRules: {
                    "regularId": [{required: true, message: "期数配置ID不能为空"}],
                    "coinType": [{required: true, message: "币种不能为空"}],
                    "incomeCoin": [{required: true, message: "收益币种不能为空"}],
                    "totalAmount": [{required: true, message: "募集总数不能为空"}],
                    "minAmount": [{required: true, message: "最小募集数不能为空"}],
                    "userSingleLimit": [{required: true, message: "单人最大募集数不能为空"}],
                    "days": [{required: true, message: "挖矿天数不能为空"}],
                    "scale": [{required: true, message: "小数位数不能为空"}],
                    "yearRate": [{required: true, message: "预期年化不能为空"}],
                    "sort": [{required: true, message: "优先级不能为空"}],
                },
                loading: false,
                coinIncomeDetail: {},
                coinIncomeOption: {
                    regularCoinId: "",
                    imcomeAmount: "",
                }
            }
        },
        filters: {
            statusFormat(val) {
                let str = "";
                switch (val) {
                    case 0:
                        str = "未开始";
                        break;
                    case 1:
                        str = "募集中";
                        break;
                    case 2:
                        str = "挖矿中";
                        break;
                    case 3:
                        str = "结算中";
                        break;
                    case 4:
                        str = "已结束";
                        break;
                    case 5:
                        str = "已计算";    
                        break;
                }
                return str;
            },
            orderStatusFormat(val) {
                let str = "";
                switch (val) {
                    case 1:
                        str = "等待挖矿";
                        break;
                    case 2:
                        str = "挖矿中";
                        break;
                    case 3:
                        str = "结算中";
                        break;
                    case 4:
                        str = "已结束";
                        break;
                    case 5:
                        str = "已计算";
                        break;
                }
                return str;
            }
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getMiningRegularCoinList() {
                api.getMiningRegularCoinList({regularId: this.currId}).then(({data}) => {
                    this.dataList = data;
                });
            },
            getMiningRegularCoinOrderList() {
                api.getMiningRegularCoinOrderList(this.queryParams).then(({data}) => {
                    this.orderList = data.list;
                    this.total = data.totalCount;
                    this.orderDialogVisible = true;
                });
            },
            addMiningRegularCoinDialog() {
                this.title = "新增";
                this.addData.regularId = this.currId;
                this.dialogVisible = true;
            },
            updateMiningRegularCoinDialog(row) {
                this.title = "修改";
                this.addData = {
                    id: row.id,
                    regularId: row.regularId,
                    coinType: row.coinType,
                    incomeCoin: row.incomeCoin,
                    totalAmount: row.totalAmount,
                    minAmount: row.minAmount,
                    userSingleLimit: row.userSingleLimit,
                    days: row.days,
                    scale: row.scale,
                    yearRate: row.yearRate,
                    sort: row.sort
                };
                this.dialogVisible = true;
            },
            calculateMiningRegularCoinIncomeDialog(id) {
                api.getMiningRegularCoinIncomeDetail({regularCoinId: id}).then(({data}) => {
                    this.coinIncomeDetail = data;
                    this.regularDialogVisible = true;
                });
                this.coinIncomeOption.regularCoinId = id;
                this.calculateMiningRegularCoinIncome = true;
                this.regularTitle = "收益计算";
            },
            transferMiningRegularCoinIncomeDialog(id) {
                api.getMiningRegularCoinIncomeDetail({regularCoinId: id}).then(({data}) => {
                    this.coinIncomeDetail = data;
                    this.regularDialogVisible = true;
                });
                this.coinIncomeOption.regularCoinId = id;
                this.calculateMiningRegularCoinIncome = false;
                this.regularTitle = "收益发放";
            },
            miningRegularCoinIncomeDetailDialog(id) {
                this.queryParams.regularCoinId = id;
                this.getMiningRegularCoinOrderList();
            },
            calculateIncome() {
                var reg = /^[0-9]+.?[0-9]*$/;
                if (this.coinIncomeOption.imcomeAmount == "") {
                    this.$message.error('发放数量不能为空!');
                    return;
                }
                if (!reg.test(this.coinIncomeOption.imcomeAmount)) {
                    this.$message.error('发放数量必须为数字!');
                    return;
                }
                api.calculateMiningRegularCoinIncomeDetail(this.coinIncomeOption).then(({data}) => {
                    this.$message.success('计算成功!');
                    this.loading = false;
                    this.regularDialogVisible = false;
                    this.getMiningRegularCoinList();
                });
            },
            transferIncome() {
                api.transferMiningRegularCoinIncomeDetail(this.coinIncomeOption).then(({data}) => {
                    this.$message.success('发放成功!');
                    this.loading = false;
                    this.regularDialogVisible = false;
                    this.getMiningRegularCoinList();
                });
            },
            addMiningRegularCoin() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.createOrUpdateMiningRegularCoin(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.getMiningRegularCoinList();
                        });
                        setTimeout(()=>{
                            this.loading = false;
                        },1000);
                    }
                });
            },
            deleteRegularCoin(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteRegularCoin({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getMiningRegularCoinList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getMiningRegularCoinOrderList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getMiningRegularCoinOrderList();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.title = "新增";
                this.addData = {
                    id: "",
                    regularId: "",
                    coinType: "",
                    incomeCoin: "",
                    totalAmount: "",
                    minAmount: "",
                    userSingleLimit: "",
                    days: "",
                    scale: "",
                    yearRate: "",
                    sort: "",
                };
            },
            clearDataOne() {
                this.loading = false;
                this.calculateMiningRegularCoinIncome = false;
                this.regularTitle = "";
                this.coinIncomeDetail = {};
                this.coinIncomeOption = {
                    regularCoinId: "",
                    imcomeAmount: "",
                };
            },
            clearDataTwo() {
                this.orderList = [];
                this.total = 0;
                this.queryParams = {regularCoinId: "", page: 1, size: 10};
            },
            backPage() {
                this.$router.go(-1);
            },
        },
        created() {
            this.currId = this.$route.query.id;
            this.getMiningRegularCoinList();
            this.getAllSupportCoin();
        }
    };
</script>

<style lang="less" scoped>

</style>
